import { NgModule } from "@angular/core";
import { CommandGridInputFormComponent } from './command-gridinput-form/command-gridinput-form.component';
import { DynamicCommandGridInputComponent } from './dynamic-command-gridinput.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { CommandGridInputDesignComponent } from './command-gridinput-design/command-gridinput-design.component';
import { CommandGridInputResultComponent } from './command-gridinput-result/command-gridinput-result.component';
import { MaterialModule } from 'src/app/shared/material.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommandGridInputService } from './command-gridinput.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CodeScannerModule } from '../../code-scanner/code-scanner.module';
import { CommandGridInputEmplacementsDialog } from './command-gridinput-emplacements-dialog/command-gridinput-emplacements-dialog.component';

@NgModule({
    declarations: [
        CommandGridInputResultComponent,
        CommandGridInputDesignComponent,
        CommandGridInputFormComponent, DynamicCommandGridInputComponent,
        CommandGridInputEmplacementsDialog
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        MatIconModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        CodeScannerModule,
    ],
    entryComponents: [
        DynamicCommandGridInputComponent,
        CommandGridInputEmplacementsDialog
    ],
    providers: [
        CommandGridInputService
    ]
})
export class CommandGridInputModule {}